import { DigitalCentersVMDTO } from 'src/app/shared/interfaces/digital-centers/digital-centers-vm-dto.interface';
import { PastellStatus } from '../pastell';

export class RapportDocumentDTO {
  file: RapportDocumentFileDTO;
  mailId: number;
  serviceProprietaireId: number;
  typeEntrantSortant: string;
}

export class RapportDocumentFileDTO {
  public baseSur?: number;
  public centreNumerisation?: DigitalCentersVMDTO;
  public centreNumerisationId?: number;
  public createdByContactId?: number;
  public dateUpload?: string;
  public description?: string;
  public editeurSourceType?: string;
  public extension?: string;
  public guid?: string;
  public id?: number;
  public isLastVersion?: boolean;
  public mailId?: number;
  public modeleId?: number;
  public name?: string;
  public pastellCircuitId?: number;
  public pastellDateLimite?: string;
  public pastellDocumentId?: number;
  public pastellStatus: PastellStatus;
  public procedureValidationCreeParContactId?: number;
  public procedureValidationId?: number;
  public procedureValidationSignatureId?: number;
  public procedureValidationSignatureOk?: number;
  public procedureValidationSignatureRoleId?: number;
  public procedureValidationSignatureServiceId?: number;
  public procedureValidationValidationId?: number;
  public procedureValidationValidationOk?: number;
  public procedureValidationValidationRoleId?: number;
  public procedureValidationValidationServiceId?: number;
  public signataireRefuse?: boolean;
  public signataireRefuseLe?: string;
  public signataireSigne?: boolean;
  public signataireSigneLe?: string;
  public version?: number;
}

export class RapportDocument {
  file: RapportDocumentFile;
  mailId: number;
  serviceProprietaireId: number;
  typeEntrantSortant: string;
  // All of those vars are used to display in the columns part of the super-table
  statusValidation?: string;
  statusValidationId?: number;
  roleSignature?: string;
  validationSignature?: string;
  statusSignature?: string;
  statusSignatureId?: number;
  serviceName?: string;
  fileName?: string;
  version?: number;
  date?: string;
  id?: number;

  constructor(data?: RapportDocument) {
    Object.assign(this, data);
  }
}

export class RapportDocumentFile {
  public baseSur?: number;
  public centreNumerisation?: DigitalCentersVMDTO;
  public centreNumerisationId?: number;
  public createdByContactId?: number;
  public dateUpload?: string;
  public description?: string;
  public editeurSourceType?: string;
  public extension?: string;
  public guid?: string;
  public id?: number;
  public isLastVersion?: boolean;
  public mailId?: number;
  public modeleId?: number;
  public name?: string;
  public pastellCircuitId?: number;
  public pastellDateLimite?: string;
  public pastellDocumentId?: number;
  public pastellStatus: PastellStatus;
  public procedureValidationCreeParContactId?: number;
  public procedureValidationId?: number;
  public procedureValidationSignatureId?: number;
  public procedureValidationSignatureOk?: number;
  public procedureValidationSignatureRoleId?: number;
  public procedureValidationSignatureServiceId?: number;
  public procedureValidationValidationId?: number;
  public procedureValidationValidationOk?: number;
  public procedureValidationValidationRoleId?: number;
  public procedureValidationValidationServiceId?: number;
  public signataireRefuse?: boolean;
  public signataireRefuseLe?: string;
  public signataireSigne?: boolean;
  public signataireSigneLe?: string;
  public version?: number;
}

export class RapportDocumentFilesValidationSignatureParams {
  SvcPropId?: number;
  ClassementId?: number;
  ClasseurId?: number;
  ChemiseId?: number;
  DtUploadMin?: string | Date; // string from backend and for backend. date is for the p-calendar
  DtUploadMax?: string | Date; // string from backend and for backend. date is for the p-calendar
  StatusValidation?: number;
  StatusSignature?: number;
  SearchTag?: 'EnCours' | 'Termine';
}
